import * as yup from 'yup';
import { requiredErrorMessage, strongPasswordSchema } from '@common/schema';

export const changePasswordSchema = yup.object().shape({
  old_password: strongPasswordSchema,
  new_password: strongPasswordSchema,
  confirm_password: yup
    .string()
    .required(requiredErrorMessage)
    .oneOf([yup.ref('new_password')], 'Passwords must match'),
});
